import axios from 'axios';
import globals from '../../globlas';
import { _paramsWithAxios, _sendWithAxios, _sendWithAxiosProgress } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API



export const registrarDownloadArquivo = async (idArquivo) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-download-arquivo/${idArquivo}`, 'POST');
}

export const registrarDownloadPasta = async (idPasta) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-download-pasta/${idPasta}`, 'POST');
}

// contabilizar=false: registra MaisVistos/AtividadesRecentes mas não conta na Análise de Acessos (RD 94908).
export const registrarVisualizacaoArquivo = async (idArquivo, contabilizar = true) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-visualizacao-arquivo/${idArquivo}?contabilizar=${contabilizar}`, 'POST');
}

// contabilizar=false: registra MaisVistos/AtividadesRecentes mas não conta na Análise de Acessos (RD 94908).
export const registrarVisualizacaoPasta = async (idPasta, contabilizar = true) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-visualizacao-pasta/${idPasta}?contabilizar=${contabilizar}`, 'POST');
}

// ------------------------------------------------ Análise de Acessos (RD 94908)

const filtrosAnalise = ({ dataInicio, dataFim, perfil, acao, idPasta }) => ({
    dataInicio,
    dataFim,
    perfil: perfil || undefined,
    acao: acao || undefined,
    idPasta: idPasta || undefined,
});

export const analiseAcessos = async (filtros) => {
    return await _paramsWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/analise-acessos`, 'GET', filtrosAnalise(filtros));
}

export const pastasAnaliseAcessos = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/analise-acessos/pastas`, 'GET');
}

export const relatorioAnaliseAcessos = async (tipo, filtros, page, pageSize) => {
    return await _paramsWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/analise-acessos/relatorio/${tipo}`, 'GET', { ...filtrosAnalise(filtros), page, pageSize });
}

export const exportarRelatorioAnaliseAcessos = async (tipo, filtros) => {
    return await axios.get(`${REACT_APP_URL_BASE_API}Dashboard/analise-acessos/relatorio/${tipo}/excel`, {
        params: filtrosAnalise(filtros),
        responseType: 'blob',
    });
}